import Amplitude from "amplitude-js";
import get from "lodash/get";
import { AmplitudeEvent } from "./Types/AmplitudeEvent";

export interface AmplitudeEmployerProps {
  providerId?: string;
  providerName?: string;
  employerId?: string;
}

class AmplitudeClient {
  private amplitudeClient?: Amplitude.AmplitudeClient;
  private employerProps?: AmplitudeEmployerProps;

  init(amplitudeKey?: string) {
    if (amplitudeKey) {
      this.amplitudeClient = Amplitude.getInstance();
      this.amplitudeClient.init(amplitudeKey);
    }
  }

  setEmployerProps(employer: AmplitudeEmployerProps) {
    this.employerProps = { ...employer };
  }

  logEvent(event: AmplitudeEvent) {
    if (!this.amplitudeClient) {
      return;
    }

    const url = window.location.href.replace(window.location.hash, "");
    const payload = {
      ...this.employerProps,
      url,
      ...get(event, "payload", {}),
    };

    this.amplitudeClient.logEvent(event.type, payload);
  }
}

export const AmplitudeProvider = new AmplitudeClient();
